import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { isRtlLanguage } from "../../utils/i18n";

function DocumentDirection() {
  const { i18n } = useTranslation();

  useEffect(() => {
    const applyDirection = (language) => {
      const isRtl = isRtlLanguage(language);
      document.documentElement.dir = isRtl ? "rtl" : "ltr";
      document.documentElement.lang = isRtl ? "ar" : "en";
    };

    applyDirection(i18n.language);
    i18n.on("languageChanged", applyDirection);
    return () => i18n.off("languageChanged", applyDirection);
  }, [i18n]);

  return null;
}

export default DocumentDirection;
